import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Helmet as ReactHelmet } from 'react-helmet';
import useAuthentication from '../../../hooks/useAuthentication';

function Helmet({ children }) {
  const { isAuthenticated, account } = useAuthentication();

  const [title, setTitle] = useState('');

  // If <title> has changed then trigger a custom page view for #12568.
  // (https://dev.azure.com/ccdg/498f5301-24ec-4ebe-aad4-41a304fa7485/_workitems/edit/12568)
  useEffect(() => {
    if (title) {
      if (window.dataLayer) {
        const pageView = {
          event: 'reactpageview',
          customPageTitle: title,
          customPagePath: window.location.href,
          authenticated: isAuthenticated(),
          authenticatedMethod: isAuthenticated()
            ? `${account().idTokenClaims.authenticationMethod} ${account().idTokenClaims.socialIssuer || 'Email'}`
            : null,
          authenticatedError: account() ? account().idTokenClaims.authenticationError || null : null
        };

        window.dataLayer.push(pageView);

        console.info('Triggering page view: ', pageView);
      }
    }
  }, [title]);

  function handleOnChange(tags, addedTags, removedTags) {
    setTitle(Array.isArray(tags.title) ? tags.title.join('') : tags.title);
  }

  return <ReactHelmet onChangeClientState={handleOnChange}>{children}</ReactHelmet>;
}

Helmet.propTypes = {
  /**
   * The nested children
   */
  children: PropTypes.node.isRequired
};

export default Helmet;
